// Маппинг районов Москвы к административным округам
export const MOSCOW_REGIONS = {
  'ЦАО': {
    name: 'ЦАО (центр)',
    districts: [
      'Арбат',
      'Басманный', 
      'Замоскворечье',
      'Красносельский',
      'Мещанский',
      'Пресненский',
      'Таганский',
      'Тверской',
      'Хамовники',
      'Якиманка'
    ]
  },
  'СЗАО': {
    name: 'СЗАО (северо-запад)',
    districts: [
      'Куркино',
      'Митино',
      'Покровское-Стрешнево',
      'Северное Тушино',
      'Строгино',
      'Хорошево-Мневники',
      'Щукино',
      'Южное Тушино'
    ]
  },
  'ЗАО': {
    name: 'ЗАО (запад)',
    districts: [
      'Внуково',
      'Дорогомилово',
      'Крылатское',
      'Кунцево',
      'Можайский',
      'Ново-Переделкино',
      'Очаково-Матвеевское',
      'Проспект Вернадского',
      'Раменки',
      'Солнцево',
      'Тропарево-Никулино',
      'Филевский парк',
      'Фили-Давыдково',
      'Конезавод',
      'Рублёво-Архангельское',
      'Сколково'
    ]
  },
  'ЮЗАО': {
    name: 'ЮЗАО (юго-запад)',
    districts: [
      'Академический',
      'Гагаринский',
      'Зюзино',
      'Коньково',
      'Котловка',
      'Ломоносовский',
      'Обручевский',
      'Северное Бутово',
      'Теплый Стан',
      'Черемушки',
      'Южное Бутово',
      'Ясенево'
    ]
  },
  'САО': {
    name: 'САО (север)',
    districts: [
      'Аэропорт',
      'Беговой',
      'Бескудниковский',
      'Войковский',
      'Восточное Дегунино',
      'Головинский',
      'Дмитровский',
      'Западное Дегунино',
      'Коптево',
      'Левобережный',
      'Молжаниновский',
      'Савеловский',
      'Сокол',
      'Тимирязевский',
      'Ховрино',
      'Хорошевский'
    ]
  },
  'ЮАО': {
    name: 'ЮАО (юг)',
    districts: [
      'Бирюлево Восточное',
      'Бирюлево Западное',
      'Братеево',
      'Даниловский',
      'Донской',
      'Зябликово',
      'Москворечье-Сабурово',
      'Нагатино-Садовники',
      'Нагатинский затон',
      'Нагорный',
      'Орехово-Борисово Северное',
      'Орехово-Борисово Южное',
      'Царицыно',
      'Чертаново Северное',
      'Чертаново Центральное',
      'Чертаново Южное'
    ]
  },
  'СВАО': {
    name: 'СВАО (северо-восток)',
    districts: [
      'Алексеевский',
      'Алтуфьевский',
      'Бабушкинский',
      'Бибирево',
      'Бутырский',
      'Лианозово',
      'Лосиноостровский',
      'Марфино',
      'Марьина роща',
      'Останкинский',
      'Отрадное',
      'Ростокино',
      'Свиблово',
      'Северное Медведково',
      'Северный',
      'Южное Медведково',
      'Ярославский'
    ]
  },
  'ВАО': {
    name: 'ВАО (восток)',
    districts: [
      'Богородское',
      'Вешняки',
      'Восточное Измайлово',
      'Восточный',
      'Гольяново',
      'Ивановское',
      'Измайлово',
      'Косино-Ухтомский',
      'Метрогородок',
      'Новогиреево',
      'Новокосино',
      'Перово',
      'Преображенское',
      'Северное Измайлово',
      'Соколиная гора',
      'Сокольники'
    ]
  },
  'ЮВАО': {
    name: 'ЮВАО (юго-восток)',
    districts: [
      'Выхино-Жулебино',
      'Капотня',
      'Кузьминки',
      'Лефортово',
      'Люблино',
      'Марьино',
      'Некрасовка',
      'Нижегородский',
      'Печатники',
      'Рязанский',
      'Текстильщики',
      'Южнопортовый'
    ]
  },
  'НАО': {
    name: 'НАО (Новомосковский)',
    districts: [
      'Внуковское',
      'Воскресенское',
      'Десёновское',
      'Кокошкино',
      'Марушкинское',
      'Московский',
      'Мосрентген',
      'Рязановское',
      'Сосенское',
      'Филимонковское',
      'Щербинка'
    ]
  },
  'ТАО': {
    name: 'ТАО (Троицкий)',
    districts: [
      'Вороновское',
      'Киевский',
      'Клёновское',
      'Краснопахорское',
      'Михайлово-Ярцевское',
      'Новофёдоровское',
      'Первомайское',
      'Роговское',
      'Троицк',
      'Щаповское'
    ]
  },
  'ЗелАО': {
    name: 'ЗелАО (Зеленоград)',
    districts: [
      'Крюково',
      'Матушкино',
      'Савёлки',
      'Силино',
      'Старое Крюково'
    ]
  }
};

// Создаем обратный маппинг: район -> округ
export const DISTRICT_TO_REGION = {};
Object.keys(MOSCOW_REGIONS).forEach(regionCode => {
  MOSCOW_REGIONS[regionCode].districts.forEach(district => {
    DISTRICT_TO_REGION[district] = regionCode;
  });
});

// Функция для получения округа по названию района
export function getRegionByDistrict(districtName) {
  return DISTRICT_TO_REGION[districtName] || null;
}

// Функция для получения всех районов округа
export function getDistrictsByRegion(regionCode) {
  return MOSCOW_REGIONS[regionCode]?.districts || [];
}

// Список всех округов для селекта
export const REGION_OPTIONS = Object.keys(MOSCOW_REGIONS).map(code => ({
  code,
  name: MOSCOW_REGIONS[code].name
}));